import type { TicketOfficeState, TicketOfficeView } from '../../../types/ticket-office';

export const shouldShowGrid = (): boolean => Boolean(localStorage.getItem('kinola-show-grid'))

export const setGridView = (view: TicketOfficeView, isGridView: boolean): void => {
    const { state, update } = view

    state.isGridView = isGridView
    update()

    if (isGridView) {
        localStorage.setItem('kinola-show-grid', '1')
    } else {
        localStorage.removeItem('kinola-show-grid')
    }

    updateLeftMenuVisibility(state)
    updateCashierMonitor(state)
}

export const updateLeftMenuVisibility = (state: TicketOfficeState) => {
    const { classList } = document.body

    if (state.isGridView) {
        classList.add('left-menu-hidden')
    } else {
        classList.remove('left-menu-hidden')
    }
}

export const updateCashierMonitor = (state: TicketOfficeState) => {
    const { isGridView, urls } = state
    $.post(isGridView ? urls.showCashierProducts : urls.hideCashierProducts)
}
